/**
 *
 * ControlStdPresens
 *
 */

import React, { memo, useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Checkbox, Button } from "antd";

// utils
import {
  getExcusedAbsenceStudents,
  generateAbsenceReason,
} from "utils/helpers/helper.generateData";
import {
  getArrayIds,
  getUniqueArrayObj,
  getObjId,
} from "utils/helpers/helper.general";

function ControlStdPresens({
  // states
  formData,
  course,
  absences,
  attendances,
  currentStep,
  controlType,
  // actoins
  nextStep,
  goToStep,
  result,
  // default props
  className,
}) {
  const childClassNames = classNames("control-std-presens", className);
  const { t } = useTranslation();

  const [students, setStudents] = useState([]);
  const [missingStudents, setMissingStudents] = useState([]);
  const [presens, setPresens] = useState([]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    if (course?._id) {
      const stdArray = course?.students.slice() || [];
      let missingArray = formData?.missing_students.slice();
      missingArray = missingArray?.sort((a, b) =>
        a?.description?.lastname.localeCompare(b?.description?.lastname),
      );
      const std = stdArray?.sort((a, b) =>
        a?.description?.lastname.localeCompare(b?.description?.lastname),
      );
      setStudents(std);
      const originalAbs = absences?.filter(a => a?.status != "refused") || [];
      const absStd = getExcusedAbsenceStudents(std, originalAbs);
      setMissingStudents(missingArray);

      filteByControlType(controlType, std, missingArray, absStd);
    }
  }, [course?.students, formData, absences]);

  // Clearing the state after unmounting a component
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      setPresens([]);
      setMissingStudents([]);
      setStudents([]);
    };
  }, []);

  const filteByControlType = (type, array, missingArray = [], abs = []) => {
    switch (type) {
      case "check-absent":
        if (Array.isArray(array)) {
          const uniqueMissing = getUniqueArrayObj(
            [...missingArray, ...abs],
            "_id",
          );
          let missStd = array?.filter(stdP => {
            const miss =
              uniqueMissing && uniqueMissing.find(std => std?._id == stdP?._id);
            return miss && stdP;
          });
          setPresens(missStd);
        }
        break;

      case "check-present":
        if (Array.isArray(array)) {
          const uniqueMissing = getUniqueArrayObj(
            [...missingArray, ...abs],
            "_id",
          );
          let prsentsStd = array?.filter(stdP => {
            const miss =
              uniqueMissing && uniqueMissing.find(std => std?._id == stdP?._id);
            return !miss && stdP;
          });
          setPresens(prsentsStd);
        }
        break;

      case "all":
        if (Array.isArray(array)) {
          const uniqueMissing = getUniqueArrayObj(
            [...missingArray, ...abs],
            "_id",
          );
          let prsentsStd = array?.filter(stdP => {
            const miss = abs && abs.find(std => std?._id == stdP?._id);
            return !miss && stdP;
          });
          setMissingStudents(abs);
          setPresens(prsentsStd);
        }
        break;
    }
  };

  const onFilter = useCallback(
    checkedValues => {
      if (controlType == "check-absent") {
        const missing = students?.filter(stdP =>
          checkedValues.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setMissingStudents(missing);
        const presenseStd = students?.filter(
          stdP => !missing.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setPresens(presenseStd);
      } else if (controlType == "check-present") {
        const presenseStd = students?.filter(stdP =>
          checkedValues.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setPresens(presenseStd);
        const missing = students?.filter(
          stdP =>
            !checkedValues.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setMissingStudents(missing);
      }
    },
    [controlType, students],
  );

  const onValid = useCallback(() => {
    !!nextStep && nextStep();
    result({
      missing_students: missingStudents,
      students: presens,
    });
  }, [missingStudents, presens, nextStep]);

  let list = controlType == "check-absent" ? missingStudents : presens;

  const stdReason = useCallback(absData => generateAbsenceReason(absData), []);

  return (
    students && (
      <div className={childClassNames}>
        <Checkbox.Group
          className="list-present-student"
          name={`ControlStdPresens`}
          onChange={onFilter}
          value={getArrayIds(list)}
        >
          {students.map((opt, inx, arr) => {
            let showAbs;
            const originalAbs = absences?.filter(a => a?.status != "refused") || [];
            const studentAbsences = absences?.filter(a => getObjId(a?.student) == getObjId(opt)) || [];
            []
            const disabeled =
              (absences &&
                originalAbs.filter(a => getObjId(a?.student) == getObjId(opt))) ||
              [];
            const hasSickness = studentAbsences?.filter(absence => absence?.status == "sick") || [];
            showAbs = studentAbsences[0];
            if (hasSickness?.length > 0) {
              showAbs = hasSickness[0];
            }
            // const isDisabeled = disabeled.length > 0 ? "disabeled" : "";
            const isDisabeled = false;
            return (
              <Checkbox
                key={`${opt?._id}-option`}
                value={opt?._id}
                className={`item-present ${isDisabeled}`}
                disabeled={disabeled.length > 0}
              >
                <span className="item-absence-title">
                  {`${opt?.description?.lastname} ${
                    opt?.description?.firstname
                  }`}
                  {showAbs && stdReason(showAbs)}
                </span>
              </Checkbox>
            );
          })}
        </Checkbox.Group>
        <div className="control-actions-wrapper">
          <Button className="next-btn" onClick={onValid}>
            {t("common.validate")}
          </Button>
        </div>
      </div>
    )
  );
}

ControlStdPresens.defaultProps = {};

export default memo(ControlStdPresens);
